<ng-container [ngTemplateOutlet]="buttonMode ? isButtonMode : isTextBoxMode"></ng-container>

<ng-template #isButtonMode>
    <dx-button [disabled]="disabled" [text]="SearchPhysicianText" class="ocl-width-120" (click)="showSearch()"></dx-button>
</ng-template>

<ng-template #isTextBoxMode>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="dx-field">
            <div class="dx-field-label">{{ label }}</div>
            <div class="dx-field-value" >
                <dx-button
                    [disabled]="disabled"
                    id="clear-btn"
                    icon="clear"
                    *ngIf="selectedPhysician !== undefined"
                    (click)="clear()"
                ></dx-button>
                <dx-text-box
                    [readOnly]="true"
                    [value]="PhysicianFullName"
                    [style.border-bottom-left-radius]="selectedPhysician === undefined ? '4px' : 0"
                    [style.border-top-left-radius]="selectedPhysician === undefined ? '4px' : 0">
                    <dx-validator *ngIf="required" [validationGroup]="validationGroup">
                        <dxi-validation-rule type="required" message="Physician is required"></dxi-validation-rule>
                    </dx-validator></dx-text-box>
                <dx-button [disabled]="disabled" id="search-btn" icon="search" (click)="showSearch()"></dx-button>
            </div>
        </div>
    </div>
</ng-template>

<app-physician-selector-dialog
    [popupVisible]="isPopupVisible"
    [patientClientId]="patientClientId"
    (closeEvent)="closeDialog($event)"
></app-physician-selector-dialog>
